import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
import { CheckLabel } from '../CheckLabel';
export var Check = function (props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.inline, inline = _b === void 0 ? false : _b, _c = props.type, type = _c === void 0 ? 'checkbox' : _c, className = props.className, labelClassName = props.labelClassName, children = props.children, onChange = props.onChange, checked = props.checked, indeterminate = props.indeterminate, id = props.id, label = props.label, secondaryText = props.secondaryText, otherProps = __rest(props, ["disabled", "inline", "type", "className", "labelClassName", "children", "onChange", "checked", "indeterminate", "id", "label", "secondaryText"]);
    var componentClass = "check-".concat(type);
    var classes = cx(bcx('check-control', {
        inline: inline,
    }), bcx(componentClass, {
        disabled: disabled,
        indeterminate: type === 'checkbox' && indeterminate ? indeterminate : undefined,
    }), className);
    return (React.createElement("div", { className: classes },
        React.createElement("input", __assign({ type: type, className: "check-control__input", id: id, onChange: onChange, checked: checked }, otherProps)),
        children || (React.createElement(React.Fragment, null,
            label && (React.createElement(CheckLabel, { id: id, className: labelClassName }, label)),
            secondaryText && (React.createElement("p", null,
                React.createElement(CheckLabel, { isSecondary: true, id: id, className: labelClassName }, secondaryText)))))));
};
Check.Label = CheckLabel;
//# sourceMappingURL=Check.js.map